import React from 'react';

import { Container } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';

import UncreditedReservationsTable from './UncreditedReservationsTable';

interface UncreditedReservationsPageContentProps {
  headerHeight: number;
}

const UncreditedReservationsPageContent = ({
  headerHeight,
}: UncreditedReservationsPageContentProps): JSX.Element => {
  const isMobile = useMediaQuery('(max-width: 768px)');

  if (isMobile) {
    return (
      <Container fluid sx={{ paddingTop: '1rem' }}>
        <UncreditedReservationsTable headerHeight={headerHeight} />
      </Container>
    );
  }
  return <UncreditedReservationsTable headerHeight={headerHeight} />;
};

export default UncreditedReservationsPageContent;
